import { FormLabel } from '@kep-ui-kit/ui-components';

import { InputCounter, StyledFormGroup } from '@selfserve/react-ui';
import { IIndexSignature } from '@selfserve/react-utils';
import { PlanItem } from '@selfserve/react-common-data';

import { PlanType } from '../data';

interface Props {
  group_items: Array<PlanItem>;
  addons: IIndexSignature<PlanType>;
  addOnName: string;
  planName: string;
  setValue: (name: string, value: any) => void;
}

export const AddonCounter = ({
  group_items,
  addons,
  addOnName,
  setValue,
  planName,
}: Props) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {group_items?.map(({ name, headline }) => {
      const value = String(addons[addOnName || '']?.quantity);
      return (
        <StyledFormGroup
          rowWithLabel
          withPadding
          withoutMargin
          greyLabel
          key={name}
        >
          <InputCounter
            id={planName}
            name={addOnName}
            value={value}
            onChange={setValue}
          />
          <FormLabel label={headline} />
        </StyledFormGroup>
      );
    })}
  </>
);
